import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=49c10308&scoped=true"
import script from "./SortableList.vue?vue&type=script&lang=ts"
export * from "./SortableList.vue?vue&type=script&lang=ts"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=49c10308&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c10308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c10308')) {
      api.createRecord('49c10308', component.options)
    } else {
      api.reload('49c10308', component.options)
    }
    module.hot.accept("./SortableList.vue?vue&type=template&id=49c10308&scoped=true", function () {
      api.rerender('49c10308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SortableList.vue"
export default component.exports